export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const STORE_TOKEN = 'STORE_TOKEN';
export const REGISTER_USER = 'REGISTER_USER';

export const TIMEOUT = 1000;

export const GET_USERS = 'GET_USERS';
export const STORE_USERS = 'STORE_USERS';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const REFRESH_USER_INFO = 'REFRESH_USER_INFO';
export const UPDATE_SELECTED_COMPANY = 'UPDATE_SELECTED_COMPANY';
export const UPDATE_USER_ID = 'UPDATE_USER_ID';

export const GET_EMPLOYEES = 'GET_EMPLOYEES';
export const STORE_EMPLOYEES = 'STORE_EMPLOYEES';

export const GET_ONLINE_EMPLOYEES = 'GET_ONLINE_EMPLOYEES';
export const STORE_ONLINE_EMPLOYEES = 'STORE_ONLINE_EMPLOYEES';

// Drives the visible reCAPTCHA checkbox on the login form after repeated
// failed attempts.
export const SET_LOGIN_CAPTCHA_REQUIRED = 'SET_LOGIN_CAPTCHA_REQUIRED';
